import {
    WITHDRAWREQLISTFORPARTNER_SUCCESS,
    WITHDRAWREQLISTFORPARTNER_FAILED,
    RESET_WITHDRAWREQLISTFORPARTNER,
    LOADING_WITHDRAWREQLISTFORPARTNER,
    NETWORK_ERROR_WITHDRAWREQLISTFORPARTNER
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_WITHDRAWREQLISTFORPARTNER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case WITHDRAWREQLISTFORPARTNER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case WITHDRAWREQLISTFORPARTNER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_WITHDRAWREQLISTFORPARTNER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_WITHDRAWREQLISTFORPARTNER:
            return (state = initialState);
        default:
            return state;
    }
};